'use client'

import { PasswordResetResult } from '@/hooks/useSetPassword'
import { useState } from 'react'
import EmailSent from './EmailSent'
import NewPassword from './NewPassword'
import ResetPassword from './ResetPassword'
import VerificationCode from './VerificationCode'

type Step = 'request' | 'verify' | 'new-password'

export type PasswordResetSuccessDetails = PasswordResetResult

interface PasswordResetWithCodeProps {
  onBackToLogin: () => void
  onResetComplete?: (details: PasswordResetSuccessDetails) => void
}

export default function PasswordResetWithCode({
  onBackToLogin,
  onResetComplete,
}: PasswordResetWithCodeProps) {
  const [step, setStep] = useState<Step>('request')
  const [resetEmail, setResetEmail] = useState('')
  const [resetToken, setResetToken] = useState('')
  const [channel, setChannel] = useState<'sms' | 'email' | null>(null)

  if (step === 'verify') {
    if (channel === 'email') {
      return <EmailSent onBackToLogin={onBackToLogin} />
    }
    return (
      <VerificationCode
        email={resetEmail}
        onBack={() => setStep('request')}
        onSuccess={(token) => {
          setResetToken(token)
          setStep('new-password')
        }}
      />
    )
  }

  if (step === 'new-password') {
    return (
      <NewPassword
        passwordResetToken={resetToken}
        onBack={() => setStep('verify')}
        onSuccess={(details) => {
          if (onResetComplete && details.authToken) {
            onResetComplete(details)
          } else {
            onBackToLogin()
          }
        }}
      />
    )
  }

  return (
    <ResetPassword
      onCancel={onBackToLogin}
      onSuccess={(email, ch) => {
        setResetEmail(email)
        setChannel(ch ?? null)
        setStep('verify')
      }}
    />
  )
}
